import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import Datepicker from '../Datepicker';

const IS_INVALID_CLASS = 'is-invalid';
const IS_FOCUSED_CLASS = 'is-focused';


class DuetDateComponent extends FormComponent {
	init(questionData) {
		this.renderInputField(questionData);
	}
	markup(value, data = {}, titleMarkup) {
		this.inputFieldContainerClass = `lta-input-field-container-${data.id}`;
		this.inputID = `lta-input-field-id-${data.id}`;
		const placeholderText = data?.placeHolder || '';
		const inputValue = data?.value || '';
		return `<div class="lta-datepicker js-datepicker u-mb-3">
					<div class="lta-datepicker-title">${titleMarkup}</div>
					<div class="lta-datepicker__wrapper ${this.inputFieldContainerClass}">
						${this.renderInstructionLabel(data.instructionText)}
						${this.renderLabel(this.inputID)}
						<div class="lta-text-input--error"></div>
						<duet-date-picker
							placeholder="${placeholderText}"
							identifier="${data?.id}"
							min="${data?.minDate}"
							max="${data?.maxDate}"
							value="${inputValue}"
						></duet-date-picker>
						<div class="lta-datepicker__icon">
							<svg class="lta-icon js-lta-text-input--btn-icon lta-datepicker__error-icon u-text-status-red" width="1.5em" height="1.5em" fill="currentColor" alt="alert" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#alert"></use>
							</svg>
							<svg class="lta-icon js-lta-text-input--btn-icon lta-datepicker__calendar-icon u-text-lta-dark-blue" width="1.5em" height="1.5em" fill="currentColor" alt="calendar" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#calendar"></use>
							</svg>
							<button type="button" class="lta-datepicker__clear-icon u-hidden" aria-label="reset date" fdprocessedid="qz4hzj">
								<svg class="lta-icon js-lta-text-input--btn-icon" width="1.5em" height="1.5em" fill="currentColor" alt="close" aria-hidden="true">
									<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
								</svg>
							</button>
						</div>
					</div>
				</div>`;
	}

	renderDuetDate(duetDatepicker) {
		if (duetDatepicker) {
			(async function () {
				const dayjs = await import('dayjs');
				const { DuetDatePicker } = await import('@duetds/date-picker/custom-element');
				const DATE_FORMAT = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
				customElements.define('duet-date-picker', DuetDatePicker);

				duetDatepicker.dateAdapter = {
					parse(value = '', createDate) {
						const matches = value.match(DATE_FORMAT);
						return matches ? createDate(matches[3], matches[2], matches[1]) : '';
					},
					format(date) {
						return dayjs.default(date).format('DD-MM-YYYY');
					}
				};

				duetDatepicker.localization = {
					buttonLabel: 'Choose date',
					placeholder: 'DD-MM-YYYY',
					selectedDateMessage: 'Selected date is',
					prevMonthLabel: 'Previous month',
					nextMonthLabel: 'Next month',
					monthSelectLabel: 'Month',
					yearSelectLabel: 'Year',
					closeLabel: 'Close window',
					calendarHeading: 'Choose a date',
					dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
					monthNames: [
						'January',
						'February',
						'March',
						'April',
						'May',
						'June',
						'July',
						'August',
						'September',
						'October',
						'November',
						'December'
					],
					monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
				};
			})();
		}
	}

	renderLabel(inputID) {
		return this.data.titlePattern
			? ``
			: `<label for=${inputID} class="lta-text-input__label u-text-grey-lta">${this.data.label}</label>`;
	}

	renderInstructionLabel(instructionLabel) {
		return instructionLabel
			? `<div class="u-mb-2"><span class="lta-text-input__label-instruction">${instructionLabel}</span></div>`
			: '';
	}

	afterRender() {
		this.componentElement = SelectorEngine.findOne('.lta-datepicker', this._element);
		this.inputFieldContainerElement = SelectorEngine.findOne('.lta-datepicker__wrapper', this._element);
		this.duetDatePicker = SelectorEngine.findOne('duet-date-picker', this.componentElement);
		this.renderDuetDate(this.duetDatePicker);
		this.datePickerComponent =
			Datepicker.getInstance(this.componentElement) || new Datepicker(this.componentElement, {});
		this.datePickerComponent.format = "DD-MM-YYYY";
		this.datePickerComponent.onChange((value) => {
			this.duetDateValue = value;
			this.handleInput(value);
		});

		if (this.data?.value) {
			setTimeout(() => {
				this.duetDateValue = this.data?.value;
				this.handleInput(this.data?.value);
			}, 100);
		}
	}

	handleInput(value) {
		if (this.data?.id === 'tournament-start-date') {
			this.startDateValue = value;
		} else if (this.data?.id === 'tournament-end-date') {
			this.endDateValue = value;
		}
		if (this.validate()) {
			this.value = {
				...this.data,
				value: value
			};
			if (this.value) {
				this.dependentQuestion = this.value.dependentQuestion;
			}
		}
	}

	validate() {
		let isValidValue = true;
		if (!this.duetDateValue) {
			isValidValue = false;
			this.addInvalidClass(this.data?.errorMessage);
		} else {
			const dateArray = this.duetDateValue.split('-');
			this.dateObject = { day: dateArray[2], month: dateArray[1], year: dateArray[0] };
		}
		return isValidValue;
	}

	dateValidate(year, month, day) {
		const parseMonth = Number.parseInt(month - 1, 10);
		const d = new Date(year, parseMonth, day);
		if (d.getFullYear() == year && d.getMonth() == parseMonth && d.getDate() == day) {
			return true;
		}
		return false;
	}
	
	removeInvalidClass() {
		const errorElement = SelectorEngine.findOne('.lta-text-input--error', this.inputFieldContainerElement);
		errorElement.innerHTML = '';
		this.inputFieldContainerElement.classList.remove(IS_INVALID_CLASS);
		this.inputFieldContainerElement.classList.remove(IS_FOCUSED_CLASS);
	}

	addInvalidClass(errorMessage) {
		const errorElement = SelectorEngine.findOne('.lta-text-input--error', this.inputFieldContainerElement);
		errorElement.innerHTML = errorMessage;
		this.inputFieldContainerElement.classList.add(IS_INVALID_CLASS);
		this.inputFieldContainerElement.classList.add(IS_FOCUSED_CLASS);
	}
}
export default DuetDateComponent;
